module.exports = __webpack_public_path__ + "img/maker.ebe0d741.jpg";